export const modalId = 'helpdesk_modal';

export enum ReportingType {
  TechnicalIssue = 'technicalIssue',
  OtherIssues = 'otherIssues',
  Suggestion = 'suggestion',
}
